import { RouterProvider } from 'react-router-dom'
import './App.css'
import router from '@routes/routes.jsx'
import { useEffect } from 'react'
import { ThemeTestToggle } from '@components/organism/common/ThemeTestToggle.jsx'
import { mStockTheme } from './utils/mStockTheme'
import { hanaTheme } from './utils/hanaTheme'

const SERVICE_THEME = {
  ASP: {
    themeClass: 'theme-kbpay',
    supportsDarkMode: false
  },
  MSTOCK: {
    themeClass: 'theme-mstock',
    supportsDarkMode: true,
    theme: mStockTheme,
    showThemeTester: import.meta.env.VITE_SHOW_MSTOCK_THEME_TESTER === 'true'
  },
  hana: {
    themeClass: 'theme-hana',
    supportsDarkMode: true,
    theme: hanaTheme,
    showThemeTester: import.meta.env.VITE_SHOW_THEME_TESTER === 'true'
  },
  jb: {
    themeClass: 'theme-jb',
    supportsDarkMode: false
  }
}

const {
  themeClass: THEME_CLASS,
  supportsDarkMode: SUPPORTS_DARK_MODE,
  theme: THEME,
  showThemeTester: SHOW_THEME_TESTER
} = SERVICE_THEME[__APP_TARGET__] ?? SERVICE_THEME.ASP

function App() {
  const isWidget = window.location.pathname.startsWith('/widgets/')

  useEffect(() => {
    sessionStorage.removeItem('__CHUNK_RELOAD__')
  }, [])

  useEffect(() => {
    if (!SUPPORTS_DARK_MODE || !THEME || isWidget) {
      return
    }

    return THEME.init()
  }, [isWidget])

  return (
    <>
      <div
        id={isWidget ? 'widget-container' : 'container'}
        className={isWidget ? undefined : THEME_CLASS}
      >
        <RouterProvider router={router} />
      </div>

      {SUPPORTS_DARK_MODE && SHOW_THEME_TESTER && !isWidget && THEME && (
        <ThemeTestToggle theme={THEME} />
      )}
    </>
  )
}

export default App
